import { useDispatch, useSelector } from "react-redux";
import WidgetItem from "./WidgetItem";
import { useEffect, useState } from "react";
//REDUCERS
import { load as loadWidget, moving as movingWidget, loadFile, loadParameter, loadTextHtml, listClear as clearWidget } from '../../../reducers/models/widgetData';
import axios from "axios";
import ErrorAdd from "../../../util/ErrorAdd";

function Widget({ idItem, idItem2, idObject, idTab, editMode, idProject, onlyRead, addedWidget }) {

    /*
        idObject:
        1	Задача
        2	Регулярная задача
        6   Регулярная задача. Трекер
        3	Доска
        4	Проект
        5	Пользователь

        editMode - Режим редактирования виджетов
        onlyRead - Только чтение. Запрет изменения (Рег.задачи.Трекер)
        addedWidget - ID добавленного виджета. Для того чтобы перевести его в режим редактирования
    */
    const dispatch = useDispatch()

    const stateWidgetData = useSelector((state) => state.widgetData);//Данные для виджета

    const [loading, setLoading] = useState(false);
    const [loading_1, setLoading_1] = useState(false);
    const [loading_2, setLoading_2] = useState(false);
    const [loading_3, setLoading_3] = useState(false);
    const [loading_4, setLoading_4] = useState(false);

    useEffect(() => {
        if (idItem != null & idObject != null) {
            setLoading(true);
            setLoading_1(true);
            setLoading_2(true);
            setLoading_3(true);
            setLoading_4(true);
            // loadingAllSet(true);
            if (idObject === 1) {
                //Загружаем список Widget  
                axios.get('/api_tracker/task/widgetList', { params: { ID_Task: idItem } })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            dispatch(loadWidget({ list: res.data.Data, id_item: idItem }));
                            setLoading_1(false);
                        }
                    })
                    .catch((err) => {
                        setLoading_1(false);
                        ErrorAdd(err, window.location.href);
                    });
                //Загружаем список Widget HTML Текст
                axios.get('/api_tracker/task/widgetHtmlList', { params: { ID_Task: idItem } })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            dispatch(loadTextHtml({ data: res.data.Data }));
                            setLoading_2(false);
                        }
                    })
                    .catch((err) => {
                        setLoading_2(false);
                        ErrorAdd(err, window.location.href);
                    });
                //Загружаем список Widget параметры
                axios.get('/api_tracker/task/widgetParameterList', { params: { ID_Task: idItem } })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            dispatch(loadParameter({ data: res.data.Data }));
                            setLoading_3(false);
                        }
                    })
                    .catch((err) => {
                        setLoading_3(false);
                        ErrorAdd(err, window.location.href);
                    });
                //Загружаем список Widget файлы
                axios.get('/api_tracker/task/widgetFileList', { params: { ID_Task: idItem } })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            dispatch(loadFile({ data: res.data.Data }));
                            setLoading_4(false);
                        }
                    })
                    .catch((err) => {
                        setLoading_4(false);
                        ErrorAdd(err, window.location.href);
                    });
            }
            if (idObject === 2) {
                //Загружаем список Widget  
                axios.get('/api_tracker/taskR/widgetList', { params: { ID_TaskR: idItem } })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            dispatch(loadWidget({ list: res.data.Data, id_item: idItem }));
                            setLoading_1(false);
                        }
                    })
                    .catch((err) => {
                        setLoading_1(false);
                        ErrorAdd(err, window.location.href);
                    });
                //Загружаем список Widget HTML Текст
                axios.get('/api_tracker/taskR/widgetHtmlList', { params: { ID_TaskR: idItem } })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            dispatch(loadTextHtml({ data: res.data.Data }));
                            setLoading_2(false);
                        }
                    })
                    .catch((err) => {
                        setLoading_2(false);
                        ErrorAdd(err, window.location.href);
                    });
                //Загружаем список Widget параметры
                axios.get('/api_tracker/taskR/widgetParameterList', { params: { ID_TaskR: idItem } })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            dispatch(loadParameter({ data: res.data.Data }));
                            setLoading_3(false);
                        }
                    })
                    .catch((err) => {
                        setLoading_3(false);
                        ErrorAdd(err, window.location.href);
                    });
                //Загружаем список Widget файлы
                axios.get('/api_tracker/taskR/widgetFileList', { params: { ID_TaskR: idItem } })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            dispatch(loadFile({ data: res.data.Data }));
                            setLoading_4(false);
                        }
                    })
                    .catch((err) => {
                        setLoading_4(false);
                        ErrorAdd(err, window.location.href);
                    });
            }
            if (idObject === 6) {
                //Загружаем список Widget  
                axios.get('/api_tracker/taskR/widgetTrackerList', { params: { ID_TaskR_Tracker: idItem } })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            dispatch(loadWidget({ list: res.data.Data, id_item: idItem }));
                            setLoading_1(false);
                        }
                    })
                    .catch((err) => {
                        setLoading_1(false);
                        ErrorAdd(err, window.location.href);
                    });
                //Загружаем список Widget HTML Текст
                axios.get('/api_tracker/taskR/widgetTrackerHtmlList', { params: { ID_TaskR_Tracker: idItem } })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            dispatch(loadTextHtml({ data: res.data.Data }));
                            setLoading_2(false);
                        }
                    })
                    .catch((err) => {
                        setLoading_2(false);
                        ErrorAdd(err, window.location.href);
                    });
                //Загружаем список Widget параметры
                axios.get('/api_tracker/taskR/widgetTrackerParameterList', { params: { ID_TaskR_Tracker: idItem } })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            dispatch(loadParameter({ data: res.data.Data }));
                            setLoading_3(false);
                        }
                    })
                    .catch((err) => {
                        setLoading_3(false);
                        ErrorAdd(err, window.location.href);
                    });
                //Загружаем список Widget файлы
                axios.get('/api_tracker/taskR/widgetTrackerFileList', { params: { ID_TaskR_Tracker: idItem } })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            dispatch(loadFile({ data: res.data.Data }));
                            setLoading_4(false);
                        }
                    })
                    .catch((err) => {
                        setLoading_4(false);
                        ErrorAdd(err, window.location.href);
                    });
            }
            if (idObject === 3) {
                //Загружаем список Widget  
                axios.get('/api_tracker/board/taskWidgetList', { params: { ID_Board_Task: idItem } })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            dispatch(loadWidget({ list: res.data.Data, id_item: idItem }));
                            setLoading_1(false);
                        }
                    })
                    .catch((err) => {
                        setLoading_1(false);
                        ErrorAdd(err, window.location.href);
                    });
                //Загружаем список Widget HTML Текст
                axios.get('/api_tracker/board/taskWidgetHtmlList', { params: { ID_Board_Task: idItem } })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            dispatch(loadTextHtml({ data: res.data.Data }));
                            setLoading_2(false);
                        }
                    })
                    .catch((err) => {
                        setLoading_2(false);
                        ErrorAdd(err, window.location.href);
                    });
                //Загружаем список Widget параметры
                axios.get('/api_tracker/board/taskWidgetParameterList', { params: { ID_Board_Task: idItem } })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            dispatch(loadParameter({ data: res.data.Data }));
                            setLoading_3(false);
                        }
                    })
                    .catch((err) => {
                        setLoading_3(false);
                        ErrorAdd(err, window.location.href);
                    });
                //Загружаем список Widget файлы
                axios.get('/api_tracker/board/taskWidgetFileList', { params: { ID_Board_Task: idItem } })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            dispatch(loadFile({ data: res.data.Data }));
                            setLoading_4(false);
                        }
                    })
                    .catch((err) => {
                        setLoading_4(false);
                        ErrorAdd(err, window.location.href);
                    });
            }
        }
    }, [idItem, idObject]);


    useEffect(() => {
        if (loading_1 === false & loading_2 === false & loading_3 === false & loading_4 === false) {
            setLoading(false);
        }
        else {
            setLoading(true);
        }
    }, [loading_1, loading_2, loading_3, loading_4]);
    //END ИНДИКАТОР ЗАГРУЗКИ

    //Изменит сортировку виджета
    function widgetMoving({ dragIndex, hoverIndex }) {
        dispatch(movingWidget({ dragIndex: dragIndex, hoverIndex: hoverIndex }));
    }
    //Сохранение измененной сортировки
    function widgetMovingSave() {
        const items = stateWidgetData.list.map((item) => {
            return { ID_Widget: item.ID_Widget, Number: item.Number, Order: item.Order }
        })

        if (idObject === 1) {
            axios.post('/api_tracker/task/widgetChangeOrder', { ID_Task: idItem, Items: items }).then((res) => { });
        }
        if (idObject === 2) {
            axios.post('/api_tracker/taskR/widgetChangeOrder', { ID_TaskR: idItem, Items: items }).then((res) => { });
        }
        if (idObject === 3) {
            axios.post('/api_tracker/board/taskWidgetChangeOrder', { ID_Board_Task: idItem, Items: items }).then((res) => { });
        }
    }

    return (
        <>
            {loading === true ?
                (
                    <div className="loader_01"></div>
                )
                :
                (
                    <>
                        {stateWidgetData.list.map((item, index) => (
                            <WidgetItem key={item.ID_Widget + '_' + item.Number} idObject={idObject} idTab={idTab} idTask={idItem} idProject={idProject} idWidget={item.ID_Widget} number={item.Number} nameWidget={item.Name} showTracker={item.Show_Tracker} moving={true} editMode={editMode} widgetMoving={widgetMoving} widgetMovingSave={widgetMovingSave} index={index} onlyRead={onlyRead} addedWidget={addedWidget} />
                        ))}
                    </>
                )}
        </>
    );
}

export default Widget;